import React from "react";
import { color, radius, space, text, weight, shadow, motion } from "../tokens";

/**
 * <Segmented> — exclusive-choice segmented control.
 *
 * Used for time-window pickers, view toggles, tabs-lite.
 *
 *   options : [{ value, label, icon? }, ...]
 *   value   : currently-selected value
 *   onChange: (nextValue) => void
 *   size    : "sm" (28) | "md" (32) default
 *
 * Container has bg.subtle background. Active thumb is white + shadow.sm.
 */
export function Segmented({ options, value, onChange, size = "md", style }) {
  const h = size === "sm" ? 28 : 32;
  return (
    <div
      style={{
        display: "inline-flex",
        gap: 2,
        padding: 3,
        borderRadius: radius.md,
        background: color.bg.subtle,
        border: `1px solid ${color.border.subtle}`,
        ...style,
      }}
      role="radiogroup"
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            style={{
              height: h,
              minWidth: h,
              padding: `0 ${space[3]}px`,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: space[2],
              border: "none",
              borderRadius: radius.sm,
              background: active ? color.bg.surface : "transparent",
              boxShadow: active ? shadow.sm : "none",
              color: active ? color.text.primary : color.text.secondary,
              fontFamily: "inherit",
              fontSize: text.base,
              fontWeight: active ? weight.semibold : weight.medium,
              cursor: "pointer",
              transition: motion.tx("all", "fast"),
            }}
          >
            {opt.icon && <span>{opt.icon}</span>}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
